module.exports = __webpack_public_path__ + "static/media/claude.ef3fdcf9.svg";